import { Container, Flex, ScrollArea, useIsMobile } from '@grupoboticario/flora-react'
import {
  Carousel,
  CarouselContent,
  NextButton,
  PreviousButton,
} from '@grupoboticario/flora-team-react-carousel'
import { PropsWithChildren } from 'react'
import { useCategoryList } from 'src/hooks/useCategoryList'
import { useSlidesToShow } from 'src/hooks/useSlidesToShow'
import { CategoryCard } from './CategoryCard'
import { CategoryListSkeleton } from './CategoryListSkeleton'
import { trackCategoryClick } from './CategoryList.analytics'
import { HomeCategoryItem } from 'src/@interfaces'

const MobileCategoryList = ({ children }: PropsWithChildren<{}>) => {
  return (
    <ScrollArea
      data-testid="mobile-category-list"
      orientation="horizontal"
      data-autotagging-flora-section="categorias"
      role="list"
      css={{ '[data-orientation=horizontal]': { display: 'none' }, paddingTop: '$4' }}
    >
      <Flex gap="$2">{children}</Flex>
    </ScrollArea>
  )
}

const DesktopCategoryList = ({ children }: PropsWithChildren<{}>) => {
  const slidesToShowDefault = useSlidesToShow()

  return (
    <Carousel
      variant="container"
      role="region"
      data-testid="desktop-category-list"
      data-autotagging-flora-section="categorias"
      css={{ paddingTop: '$4' }}
    >
      <PreviousButton
        aria-controls="carousel"
        aria-label="Ver a categoria anterior"
      />
      <CarouselContent
        role="list"
        aria-label="Categorias"
        slidesToShow={slidesToShowDefault}
        infinite={false}
      >
        {children}
      </CarouselContent>
      <NextButton
        aria-controls="carousel"
        aria-label="Ver a próxima categoria"
      />
    </Carousel>
  )
}

export type CategoryListProps = {
  resellerSlug: string
}

export const CategoryList = ({ resellerSlug }: CategoryListProps) => {
  const isMobile = useIsMobile()
  const { categoryList, isLoading } = useCategoryList()
  const CategoryCardList = categoryList.map((category, index) => (
    <CategoryCard
      key={category.title + category.url}
      {...category}
      url={`/${resellerSlug}${category.url}`}
      onClick={() => handleCategoryClick(category, index)}
    />
  ))

  const handleCategoryClick = ({ title }: HomeCategoryItem, index: number) => {
    trackCategoryClick({ name: title, index })
  }

  if (isLoading) {
    return <CategoryListSkeleton />
  }

  return (
    <>
      {isMobile ? (
        <MobileCategoryList>{CategoryCardList}</MobileCategoryList>
      ) : (
        <DesktopCategoryList>{CategoryCardList}</DesktopCategoryList>
      )}
    </>
  )
}
